import { createMissionStatement } from "api";
import Notify from "utils/notify";
import { ActionTypes } from "./types";
import { getCookie } from "utils/StorageVariables";
import { RetrieveMasterPlanDetails } from "Redux/RetrieveMasterPlan/action";
import { SetMissionStatement } from "Redux/GetMissionStatement/action";

export const MissionStatement = (Data, setMissionStatementGoal, missionStatmentGoal, setCurrentStep, onError) => async (dispatch) => {
  try {

    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await createMissionStatement(Data);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 201) {
      setCurrentStep(7);
      dispatch(SetMissionStatement(data))

      setMissionStatementGoal({ ...missionStatmentGoal, hasMissionStatement: true });
      let MasterPlanId = getCookie("MasterPlanId");
      dispatch(RetrieveMasterPlanDetails(MasterPlanId, false));

    }
  } catch (error) {
    // ARO-7161: always surface the failure (500s carry no `error` key) and let
    // the caller leave its "Generating your mission statement" loading state.
    Notify.error(error, true);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
    if (onError) onError(error);
  }
};

export const SetCreateMissionStatement = (payload) => async (dispatch) => {

  dispatch({
    type: ActionTypes.SUCCESS,
    payload,
  });

};
